<template>
    <g @mousemove="placeHover"
       @mouseleave="placeUnHover"
       :id="'place'+place.id"
       class="place"
       :class="[{'selected':inCart}, {'closed':place.status !== 10 }]"
       @click="placeClick()"
    >
        <!-- Прозрачный элемент, заполняющий расстояние между кругами, чтобы была отработка без промежутков между ними -->
        <rect :x="rect.x" :y="rect.y" :width="rect.w" :height="rect.h"
              fill="transparent"/>
        <circle :r="radius"
                :cx="cx"
                :cy="cy"
                :style="styles">
        </circle>
        <transition name="fade">
            <text :x="cx" :y="cy" class="place__number"
                  text-anchor="middle"
                  alignment-baseline="central"
                  v-if="(showNumber || inCart)"
            >
                {{place.name}}
            </text>
        </transition>
    </g>
</template>

<script>
    // import {eventBus} from '../event-bus.js';
    import {mapGetters, mapState} from 'vuex'

    // const HOVERED = 100;
    // const SELECTED = 101;
    // const FREE = 0;

    // Статусы мест/билетов
    /// Новый
    // const New = 0;
    /// В продаже
    const OnSale = 10;
    /// На реализации
    // const OnRetail = 20;
    /// Забронирован
    // const Blocked = 30;
    /// Продан
    // const Sold = 40;
    /// Выполнен проход
    // const Used = 50;
    /// Переоценка
    // const Revaluation = 60;
    /// Аннулирован
    // const Nulled = 100;

    export default {
        name: "Seat",
        props: ['place', 'lengthSeats', 'indexThisSeat'],
        data() {
            return {
                radius: 17.5,
                showNumber: false,
                // hovered: false,
                // selected: false,
                // color: '#d3d3d3',
                // classes: 'wgt-place',
                // font_size: "5px"

                rect: {
                    x: this.place.position.x,
                    y: this.place.position.y,
                    w: 50,
                    h: 50,
                }
            }
        },
        computed: {
            ...mapState({
                ticketsCart: state => state.cart.items,
            }),
            ...mapGetters('cart', {
                // cartTotalPrice: 'cartTotalPrice',
                cartCountTickets: 'cartCountTickets'
            }),
            cx: function () {
                return this.place.position.x + this.radius + 7;
            },
            cy: function () {
                return this.place.position.y + this.radius + 7;
            },
            styles: function () {
                // if (this.state === FREE) {
                //     this.color = 'hsl(' + parseInt(this.price) + ', 50%, 50%)';
                //     return {
                //         'fill': this.color,
                //         'cursor': 'pointer !important'
                //     }
                // }
                let style = {
                    'fill': this.place.color,
                }
                if (this.place.status === OnSale) {
                    style.cursor = 'pointer !important'
                }
                return style;
            },
            inCart: function () {
                let indexInCart = this.ticketsCart.findIndex(item => item.id === this.place.id);
                return indexInCart !== -1;
            }
        },
        methods: {
            checkRendering() {
                // Проверяем, отрисовалась ли вся схема
                if (this.indexThisSeat === this.lengthSeats - 1) {
                    this.$nextTick(function () {
                        // $nextTick - важно для проверки момента, когда отрисована вся схема
                        // Send the event on a channel (endRenderSeats)
                        this.$events.fire('endRenderSeats');
                    })
                }
            },
            placeHover(event) {
                // Если место имеет статус "В продаже"
                if (this.place.status === OnSale) {
                    this.showNumber = true;
                    let seatInfo = {
                        section: this.place.sectionName,
                        price: this.place.price,
                        row: this.place.titleLine,
                        number: this.place.name,
                        position: {
                            left: event.pageX + "px",
                            top: event.pageY + "px"
                        }
                    };
                    this.$events.fire('showTooltip', seatInfo);
                }
            },
            placeUnHover() {
                this.showNumber = false;
                this.$events.fire('hideTooltip');
            },
            placeClick() {
                if (this.place.status === OnSale) {
                    switch (this.inCart) {
                        case false:
                            if (this.cartCountTickets >= 9) {
                                // Проверяем, чтобы в корзине небыло больше 9 билетов
                                this.$events.fire('maxTickets');
                            } else {
                                this.showNumber = true;
                                this.$store.dispatch('cart/addTicketToCart', this.place);
                            }
                            break;

                        case true:
                            this.showNumber = false;
                            this.$store.dispatch('cart/removeTicketFromCart', this.place.id);
                            break;

                        default:

                            break;
                    }
                }
            },
        },
        mounted() {
            this.checkRendering();
        }
    }
</script>

<style scoped lang="scss">

    .place {
        opacity: .8;

        &:not(.closed) {
            transition: 0.2s ease-in-out;
            cursor: pointer;

            circle {
                transition: 0.2s ease-in-out;
            }

            &:hover {
                opacity: 1;

                circle {
                    r: 20;
                }
            }

            &.selected {
                opacity: 1;

                circle {
                    r: 22;
                    stroke: var(--white);
                    stroke-width: .75;
                }

                &:hover {
                    circle {
                        r: 20;
                    }
                }
            }
        }

        &.closed {
            cursor: not-allowed;
        }

        &__number {
            fill: var(--white);
            font-size: 1.25rem;
        }
    }
</style>
